<section class="container-fluid astral-contract-form">
  <app-form-header [contextInfo]="titleContextInfo" [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (dataContext) {
    @if (dataContext.isNew) {
      <ng-container *ngTemplateOutlet="newContractLayout"></ng-container>
    } @else {
      <astral-form [form]="form" [columns]="4" (formSubmit)="onSubmit()">
        <section class="astral-grid-full astral-section-surface">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-input [control]="form.controls['leaseAgreementNumber']"></astral-input>
            <astral-input
              class="astral-grid-span-2"
              label="COMMON.RENTAL_OBJECT"
              [value]="dataContext.rentalObject"
              [readonly]="true"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.READ_ONLY_FIELDS'"
            ></astral-input>
            <astral-input
              label="LEASE_AGREEMENT.STATUS"
              [value]="dataContext.statusCaption | translate"
              [readonly]="true"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.STATUS'"
            ></astral-input>
          </astral-layout-group>
        </section>
      </astral-form>
      <div class="astral-content-width astral-accordion-stack">
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.RENTAL_OBJECT'">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-input label="COMMON.RENTAL_OBJECT" [value]="dataContext.rentalObject" [readonly]="true"></astral-input>
            <astral-input
              label="RENTAL_OBJECT_TYPE_FORM.CATEGORY_PARKING"
              [value]="dataContext.rentalObjectTypeName"
              [readonly]="true"
            ></astral-input>
            <astral-input label="PARKING_FORM.PARKING_NUMBER_LABEL" [value]="parkingNumber | translate" [readonly]="true"></astral-input>
            <div class="astral-link-action create-button astral-form-adjacent-action">
              <astral-button variant="link-button" type="button" labelKey="COMMON.OPEN_RENTAL_OBJECT" (click)="onOpenRentalObjectClicked()">
              </astral-button>
            </div>
            <astral-input label="COMMON.COMPANY" [value]="dataContext.companyName" [readonly]="true"></astral-input>
            <astral-input label="COMMON.PROPERTY" [value]="dataContext.propertyName" [readonly]="true"></astral-input>
            <astral-input class="astral-grid-full" [control]="form.controls['usage']"></astral-input>
          </astral-layout-group>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.TENANT_NAME'" [allowWidthExpansion]="true">
          <div class="astral-stack-l">
            <div class="astral-content-width">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
                <div class="astral-grid-full">
                  <app-tenant-select [dataContext]="dataContext" [form]="form" (tenantOneChange)="onTenantOneChange($event)"></app-tenant-select>
                </div>
              </astral-layout-group>
            </div>
            @if (dataContext.hasOtherLeaseAgreements) {
              <div class="astral-grid-full astral-stack-l">
                <p class="help-text">{{ 'LEASE_AGREEMENT.HELP_TEXT.OTHER_LEASE_AGREEMENTS' | translate }}</p>
                <app-list-view
                  [columnDefinition]="otherLeaseAgreementColumnDefinition"
                  [itemsSource]="dataContext.otherLeaseAgreements"
                  [preferencesKey]="'parking-contract.other-lease-agreements'"
                  (rowClick)="onOtherLeaseAgreementClicked($event)"
                ></app-list-view>
              </div>
            }
          </div>
        </astral-accordion>
        @if (form) {
          <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.HEADER'">
            <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
              <div class="astral-layout-item">
                <astral-date-picker
                  [control]="form.controls['agreementDate']"
                  [model]="dataContext.agreementDate"
                  [label]="'LEASE_AGREEMENT.AGREEMENT_DATE'"
                  [isRequired]="true"
                ></astral-date-picker>
              </div>
              <div class="astral-grid-full">
                <app-notice-period
                  [form]="form.controls['noticePeriod']"
                  [dataContext]="dataContext"
                  (fromChange)="onNoticePeriodFromChanged($event)"
                ></app-notice-period>
              </div>
              <div class="astral-grid-full">
                <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                  <div class="astral-layout-item">
                    <astral-date-picker
                      [control]="form.controls['giveUpSecurityOfTenureFrom']"
                      [model]="dataContext.giveUpSecurityOfTenureFrom"
                      [label]="'LEASE_AGREEMENT.GIVE_UP_SECURITY_OF_TENURE_FROM'"
                    ></astral-date-picker>
                  </div>
                  <div class="astral-layout-item">
                    <astral-date-picker
                      [control]="form.controls['giveUpSecurityOfTenureTo']"
                      [model]="dataContext.giveUpSecurityOfTenureTo"
                      [label]="'LEASE_AGREEMENT.GIVE_UP_SECURITY_OF_TENURE_TO'"
                    ></astral-date-picker>
                  </div>
                </astral-layout-group>
              </div>
            </astral-layout-group>
          </astral-accordion>
        }
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT_ROW.LIST_HEADER'" [allowWidthExpansion]="true">
          <div class="astral-stack-l">
            <div class="astral-grid-full">
              <app-lease-rows
                [form]="form"
                [currency]="dataContext.currencyCode"
                [leaseStartDate]="fromDate"
                [currentDuePeriodFrom]="dataContext.currentDuePeriodFrom"
                [currentDuePeriodTo]="dataContext.currentDuePeriodTo"
                [currentPeriodText]="dataContext.currentPeriodText"
                [rentalObjectSize]="rentalObjectSurface"
                [leaseAgreementInvoicePeriod]="dataContext.invoicePeriod"
                [leaseAgreementCategory]="'Parking'"
                [cultureName]="dataContext.cultureName"
                [itemsSource]="leaseAgreementRows"
                [entityId]="dataContext.id"
                [companyId]="dataContext.company"
                [contractService]="dataService"
                (itemSourceChange)="onItemSourceChange($event)"
                (leaseRowsChange)="onLeaseRowsChange($event)"
              ></app-lease-rows>
            </div>
            <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1" [span]="'full'">
              <app-money-box [control]="form.controls['originalContractualRent']"></app-money-box>
            </astral-layout-group>
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
              <astral-select
                [control]="form.controls['rentPayment']"
                [itemsSource]="rentPayments"
                [helpText]="'PARKING_LEASE_AGREEMENT_FORM.HELP_TEXT.RENTPAYMENT'"
              ></astral-select>
              @if (!isRentPaymentCustomOrTotal) {
                <astral-select
                  [control]="form.controls['parkingElectricityPayment']"
                  [itemsSource]="parkingElectricityPayments"
                ></astral-select>
                <astral-select
                  [control]="form.controls['parkingChargingElectricityPayment']"
                  [itemsSource]="parkingElectricityPayments"
                ></astral-select>
              }
            </astral-layout-group>
            @if (isRentPaymentCustom) {
              <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1" [span]="'full'">
                <astral-textarea
                  [control]="form.controls['rentPaymentTerms']"
                  [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENT_PAYMENT_TERMS'"
                ></astral-textarea>
              </astral-layout-group>
            }
          </div>
        </astral-accordion>
        @if (dataContext.id) {
          <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT_INFORMATION_ROW.HEADER'">
            <app-lease-agreement-information-rows [entityId]="dataContext.id"></app-lease-agreement-information-rows>
          </astral-accordion>
        }
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.INVOICING_HEADER'">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <div class="astral-grid-full">
              <app-contract-invoicing
                [form]="form"
                [dataContext]="dataContext"
                [tenantOne]="tenantOne"
                [addressForm]="form.controls['invoiceAddress']"
                [contractSpecificInvoiceAddress]="form.controls['individualInvoiceAddress'].value"
                [category]="dataContext.category"
                [company]="dataContext.company"
              ></app-contract-invoicing>
            </div>
            <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.INVOICE_ADDRESS_HEADER' | translate }}</h4>
            <astral-toggle
              [control]="form.controls['individualInvoiceAddress']"
              [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INDIVIDUAL_INVOICE_ADDRESS'"
            ></astral-toggle>
            <h6 class="astral-grid-full">{{ individualAddressMessage | translate }}</h6>
            <div class="astral-grid-full">
              <app-postal-address
                [group]="form.controls['invoiceAddress']"
                [model]="invoiceAddress"
                [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
                [showName]="true"
                [mandatory]="true"
                [title]="''"
              ></app-postal-address>
            </div>
          </astral-layout-group>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'LEASE_AGREEMENT.TERMS'">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-textarea class="astral-grid-full" [control]="form.controls['specialTerms']"></astral-textarea>
          </astral-layout-group>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'REPRESENTATIVE.BLOCK_NAME'" [counter]="dataContext.representatives.length" [allowWidthExpansion]="true">
          <div class="astral-layout-item">
            <app-representative-manager [dataContext]="dataContext" [form]="form"></app-representative-manager>
          </div>
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'COMMON.NOTE'" [indicator]="!!dataContext.note">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-textarea class="astral-grid-full" [control]="form.controls['note']"></astral-textarea>
          </astral-layout-group>
        </astral-accordion>
        @if (dataContext.fastighetsagarnaDokumentActive) {
          <astral-accordion
            class="astral-grid-full"
            [header]="'FASTIGHETSAGARNA_DOKUMENT.FASTIGHETSAGARNA_DOKUMENT'"
            [helpText]="'FASTIGHETSAGARNA_DOKUMENT.HELP_TEXT.ACCORDION_HEADER'"
            [allowWidthExpansion]="true"
            >
            <div class="astral-layout-item">
              <app-form-cases-fastighetsagarna-dokument
                [form]="form"
                [itemsSource]="dataContext.leaseAgreementForms"
                [leaseAgreementId]="dataContext.id"
                [leaseAgreementCategory]="2"
              ></app-form-cases-fastighetsagarna-dokument>
            </div>
          </astral-accordion>
        }
        @if (form) {
          <astral-accordion class="astral-grid-full" [header]="'CONSUMPTION.CONSUMPTION'" (stateChanged)="allowSectionInit('imdConsumption')" [allowWidthExpansion]="true">
            <div class="astral-layout-item">
              <app-information-block [text]="'CONSUMPTION.CONSUMPTION_LEASE_AGREEMENT_DESCRIPTION' | translate"></app-information-block>
            </div>
            @if (isSectionAllowed('imdConsumption')) {
              <div class="astral-layout-item wrap-rows">
                <app-list-view
                  [columnDefinition]="imdConsumptionColumnDefinition"
                  [itemsSource]="imdConsumption"
                  [preferencesKey]="'parking-contract.imd-consumption'"
                ></app-list-view>
              </div>
            }
          </astral-accordion>
        }
        <astral-accordion
          class="astral-grid-full"
          [header]="'FAULT_NOTIFICATION.EDIT_HEADER'"
          [helpText]="'FAULT_NOTIFICATION.HELP_TEXT.LEASE_AGREEMENT_INFORMATION'"
          (stateChanged)="allowSectionInit('faultNotification')"
          [allowWidthExpansion]="true">
          @if (isSectionAllowed('faultNotification')) {
            <div class="astral-layout-item">
              <app-list-view
                [columnDefinition]="faultNotificationColumnDefinition"
                [itemsSource]="dataContext.faultNotifications"
                [preferencesKey]="'parking-contract.fault-notifications'"
                (rowClick)="onFaultNotificationRowClicked($event)"
              ></app-list-view>
            </div>
          }
        </astral-accordion>
        <astral-accordion class="astral-grid-full" [header]="'DOCUMENT.DOCUMENTS'" [counter]="leaseAgreementDocumentCount" [fragment]="documentsFragment" [allowWidthExpansion]="true">
          <div class="astral-stack-l">
            <div class="astral-layout-item">
              <astral-button variant="primary" type="button" labelKey="LEASE_AGREEMENT.COMMAND.LINK_DOCUMENT" icon="plus" (click)="linkDocument()"></astral-button>
            </div>
            <div class="astral-layout-item">
              <app-lease-agreement-document-manager [leaseAgreementId]="dataContext?.id" (countChange)="leaseAgreementDocumentCount = $event"></app-lease-agreement-document-manager>
            </div>
          </div>
        </astral-accordion>
        @if (form) {
          <astral-accordion class="astral-grid-full" [header]="'LOG.HEADER'" (stateChanged)="allowSectionInit('logs')" [allowWidthExpansion]="true">
            @if (isSectionAllowed('logs')) {
              <div class="astral-layout-item wrap-rows">
                <app-list-view [columnDefinition]="logColumnDefinition" [itemsSource]="logs" [preferencesKey]="'parking-contract.logs'"></app-list-view>
              </div>
            }
          </astral-accordion>
        }
      </div>
    }
  }


  <ng-template #newContractLayout>
    <div class="astral-surface-stack">
      <app-information-block class="astral-content-width" [text]="'LEASE_AGREEMENT.INFORMATION_TEXT.NEW_LEASE_AGREEMENT' | translate"></app-information-block>
      <astral-form class="astral-content-width--with-list-surface" [form]="form" [columns]="4" (formSubmit)="onSubmit()">
      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.RENTAL_OBJECT' | translate }}</h4>
          <app-vacant-period-autocomplete [category]="'Parking'" [control]="form.controls['rentalObject']"></app-vacant-period-autocomplete>
          <astral-input [control]="form.controls['leaseAgreementNumber']"></astral-input>
          @if (dataContext.blockingWarning) {
            <h6 class="astral-grid-full">{{ dataContext.blockingWarning }}</h6>
          }
          <astral-input class="astral-grid-full" [control]="form.controls['usage']"></astral-input>
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.TENANT_NAME' | translate }}</h4>
          <div class="astral-grid-full">
            <app-tenant-select [dataContext]="dataContext" [form]="form" (tenantOneChange)="onTenantOneChange($event)"></app-tenant-select>
          </div>
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.HEADER' | translate }}</h4>
          <astral-date-picker
            [control]="form.controls['agreementDate']"
            [model]="dataContext.agreementDate"
            [label]="'LEASE_AGREEMENT.AGREEMENT_DATE'"
            [isRequired]="true"
          ></astral-date-picker>
          <div class="astral-grid-full">
            <app-notice-period
              [form]="form.controls['noticePeriod']"
              [dataContext]="dataContext"
              (fromChange)="onNoticePeriodFromChanged($event)"
            ></app-notice-period>
          </div>
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface astral-section-surface--list-width">
        <div class="astral-form-stack astral-form-stack--relaxed">
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT_ROW.LIST_HEADER' | translate }}</h4>
          <div class="astral-grid-full">
            <app-lease-rows
              [form]="form"
              [currency]="dataContext.currencyCode"
              [leaseStartDate]="fromDate"
              [currentDuePeriodFrom]="dataContext.currentDuePeriodFrom"
              [currentDuePeriodTo]="dataContext.currentDuePeriodTo"
              [currentPeriodText]="dataContext.currentPeriodText"
              [rentalObjectSize]="rentalObjectSurface"
              [leaseAgreementInvoicePeriod]="dataContext.invoicePeriod"
              [leaseAgreementCategory]="'Parking'"
              [cultureName]="dataContext.cultureName"
              [itemsSource]="leaseAgreementRows"
              [entityId]="dataContext.id"
              [companyId]="dataContext.company"
              [contractService]="dataService"
              (itemSourceChange)="onItemSourceChange($event)"
              (leaseRowsChange)="onLeaseRowsChange($event)"
            ></app-lease-rows>
          </div>
          <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1" [span]="'full'">
            <app-money-box [control]="form.controls['originalContractualRent']"></app-money-box>
          </astral-layout-group>
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
            <astral-select
              [control]="form.controls['rentPayment']"
              [itemsSource]="rentPayments"
              [helpText]="'PARKING_LEASE_AGREEMENT_FORM.HELP_TEXT.RENTPAYMENT'"
            ></astral-select>
            @if (!isRentPaymentCustomOrTotal) {
              <astral-select
                [control]="form.controls['parkingElectricityPayment']"
                [itemsSource]="parkingElectricityPayments"
              ></astral-select>
              <astral-select
                [control]="form.controls['parkingChargingElectricityPayment']"
                [itemsSource]="parkingElectricityPayments"
              ></astral-select>
              }
            </astral-layout-group>
          @if (isRentPaymentCustom) {
            <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1" [span]="'full'">
              <astral-textarea
                [control]="form.controls['rentPaymentTerms']"
                [helpText]="'LEASE_AGREEMENT.HELP_TEXT.RENT_PAYMENT_TERMS'"
              ></astral-textarea>
            </astral-layout-group>
          }
        </div>
      </div>

      @if (dataContext.id) {
        <div class="astral-grid-full astral-section-surface">
          <h4>{{ 'LEASE_AGREEMENT_INFORMATION_ROW.HEADER' | translate }}</h4>
          <app-lease-agreement-information-rows [entityId]="dataContext.id"></app-lease-agreement-information-rows>
        </div>
      }

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.INVOICING_HEADER' | translate }}</h4>
          <div class="astral-grid-full">
            <app-contract-invoicing
              [form]="form"
              [dataContext]="dataContext"
              [tenantOne]="tenantOne"
              [addressForm]="form.controls['invoiceAddress']"
              [contractSpecificInvoiceAddress]="form.controls['individualInvoiceAddress'].value"
              [category]="dataContext.category"
              [company]="dataContext.company"
            ></app-contract-invoicing>
          </div>
          <h4 class="astral-grid-full">{{ 'LEASE_AGREEMENT.INVOICE_ADDRESS_HEADER' | translate }}</h4>
          <astral-toggle
            [control]="form.controls['individualInvoiceAddress']"
            [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INDIVIDUAL_INVOICE_ADDRESS'"
          ></astral-toggle>
          <h6 class="astral-grid-full">{{ individualAddressMessage | translate }}</h6>
          <div class="astral-grid-full">
            <app-postal-address
              [group]="form.controls['invoiceAddress']"
              [model]="invoiceAddress"
              [nameLabel]="'ADDRESS_FORM.RECIPIENT_LABEL'"
              [showName]="true"
              [mandatory]="true"
              [title]="''"
            ></app-postal-address>
          </div>
        </astral-layout-group>
      </div>

      <div class="astral-grid-full astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [span]="'full'">
          <astral-textarea class="astral-grid-full" [control]="form.controls['specialTerms']"></astral-textarea>
        </astral-layout-group>
      </div>
      </astral-form>
    </div>
  </ng-template>
</section>
